// import React, { useState, useRef, useCallback } from 'react';
// import {
//   FiUpload, FiEdit3, FiZap, FiCheckCircle, FiMail, FiDownload,
//   FiX, FiFile, FiAlertCircle, FiRefreshCw,
// } from 'react-icons/fi';
// import { uploadInvoice, saveInvoiceReview, pushInvoiceToSap } from '../../utils/ocrApi';

// const STEPS = ['Upload Invoices', 'Review & Push'];

// // ── Helpers ───────────────────────────────────────────────────────────────────
// function flattenExtracted(extractedData) {
//   const rows = [];
//   if (!Array.isArray(extractedData)) return rows;
//   extractedData.forEach((arr, ii) => {
//     if (Array.isArray(arr)) {
//       arr.forEach((inv, di) => {
//         const { Items, items, ...rest } = inv;
//         rows.push({ ...rest, _items: Items || items || [], _id: `${ii}-${di}` });
//       });
//     }
//   });
//   return rows;
// }

// function buildEditRow(inv) {
//   const invoiceNumber =
//     inv['Invoice Number'] || inv['invoice_number'] || inv['InvoiceNumber'] || '';
//   return {
//     invoice_number:         invoiceNumber,
//     _originalInvoiceNumber: invoiceNumber,
//     invoice_date:           inv['Invoice Date']  || inv['invoice_date']          || inv['Date']         || '',
//     invoice_total:          inv['Invoice Total'] || inv['invoice_total']         || inv['Total Amount'] || inv['Total'] || '',
//     purchase_order_number:  inv['PO Number']     || inv['purchase_order_number'] || inv['PO No']        || '',
//     ap_processor:           inv['AP Processor']  || inv['ap_processor']          || localStorage.getItem('userEmail') || '',
//   };
// }

// function displayKeys(inv) {
//   return Object.keys(inv).filter((k) => !k.startsWith('_'));
// }

// const EXT_COLORS = { pdf:'#e53e3e', png:'#6b46c1', jpg:'#6b46c1', jpeg:'#6b46c1', xlsx:'#2f855a', xls:'#2f855a' };
// const fileColor  = (ext) => EXT_COLORS[ext.toLowerCase()] || '#4a5568';
// const fmtBytes   = (b)   => b<1024?`${b} B`:b<1048576?`${(b/1024).toFixed(1)} KB`:`${(b/1048576).toFixed(1)} MB`;

// function statusCfg(ps) {
//   if (ps.loading) return { border:'#93c5fd', bg:'rgba(239,246,255,.55)', accent:'#2563eb', pillBg:'#dbeafe', pillColor:'#1e40af', pillBorder:'#bfdbfe', label:'Pushing…' };
//   if (ps.success) return { border:'#6ee7b7', bg:'rgba(236,253,245,.65)', accent:'#059669', pillBg:'#d1fae5', pillColor:'#065f46', pillBorder:'#a7f3d0', label:'Pushed ✓' };
//   if (ps.error)   return { border:'#fca5a5', bg:'rgba(255,241,242,.65)', accent:'#dc2626', pillBg:'#fee2e2', pillColor:'#991b1b', pillBorder:'#fca5a5', label:'Failed' };
//   return             { border:'var(--border)', bg:'rgba(255,255,255,.7)', accent:'var(--blue-1)', pillBg:'#f1f5f9', pillColor:'#475569', pillBorder:'#e2e8f0', label:'Pending' };
// }

// // ── Divider ───────────────────────────────────────────────────────────────────
// const Divider = ({ label }) => (
//   <div style={{ display:'flex', alignItems:'center', gap:10, margin:'16px 0 12px' }}>
//     <div style={{ flex:1, height:1, background:'rgba(216,227,240,.6)' }}/>
//     <span style={{ fontSize:'0.65rem', fontWeight:800, color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.8px', whiteSpace:'nowrap' }}>{label}</span>
//     <div style={{ flex:1, height:1, background:'rgba(216,227,240,.6)' }}/>
//   </div>
// );

// // ── Main Component ────────────────────────────────────────────────────────────
// const OCRProcess = ({ onUploadComplete }) => {
//   const [step,        setStep]        = useState(0);
//   const [dragOver,    setDragOver]    = useState(false);
//   const [files,       setFiles]       = useState([]);
//   const [uploading,   setUploading]   = useState(false);
//   const [uploadError, setUploadError] = useState('');
//   const [uploadStage, setUploadStage] = useState('idle');

//   const [extractedRows, setExtractedRows] = useState([]);
//   const [editedRows,    setEditedRows]    = useState([]);
//   const [pushStates,    setPushStates]    = useState([]);
//   const [selectedIdx,   setSelectedIdx]   = useState(0);

//   const fileRef = useRef(null);

//   // ── File management ───────────────────────────────────────────────────────
//   const addFiles = (incoming) => {
//     if (!incoming?.length) return;
//     setUploadError('');
//     setFiles((prev) => {
//       const existing = new Set(prev.map((f) => f.name));
//       return [...prev, ...Array.from(incoming).filter((f) => !existing.has(f.name))];
//     });
//   };
//   const removeFile = (name) => setFiles((p) => p.filter((f) => f.name !== name));
//   const handleDrop  = (e)    => { e.preventDefault(); setDragOver(false); addFiles(e.dataTransfer.files); };

//   // ── Push ──────────────────────────────────────────────────────────────────
//   const doPush = useCallback(async (idx, rows) => {
//     const row = rows[idx];
//     const orig = row._originalInvoiceNumber || row.invoice_number;

//     setPushStates((p) => { const c=[...p]; c[idx]={...c[idx], loading:true, error:null}; return c; });

//     try {
//       let pushNum = orig;
//       if (row.invoice_number !== orig) {
//         await saveInvoiceReview(orig, row);
//         pushNum = row.invoice_number;
//         setEditedRows((p) => { const c=[...p]; c[idx]={...c[idx], _originalInvoiceNumber:row.invoice_number}; return c; });
//       }

//       const d      = await pushInvoiceToSap(pushNum, row.ap_processor);
//       const failed = d?.success===false || d?.status==='error' || /failed|error|not found/i.test(d?.message||'');

//       setPushStates((p) => {
//         const c=[...p];
//         c[idx] = failed
//           ? { ...c[idx], loading:false, success:null, error:d?.message||'Push to SAP failed.', showEdit:true }
//           : { ...c[idx], loading:false, success:d?.message||'Pushed to SAP successfully.', error:null, showEdit:false };
//         return c;
//       });
//     } catch (err) {
//       setPushStates((p) => { const c=[...p]; c[idx]={...c[idx], loading:false, success:null, error:err.message, showEdit:true}; return c; });
//     }
//   }, []);

//   // ── Upload ────────────────────────────────────────────────────────────────
//   const handleUpload = useCallback(async () => {
//     if (!files.length) return;
//     setUploading(true); setUploadError(''); setUploadStage('uploading');
//     try {
//       setUploadStage('processing');
//       const data = await uploadInvoice(files);
//       setUploadStage('done');

//       let extracted = [];
//       if (data.results?.extracted_data) extracted = data.results.extracted_data;
//       else if (Array.isArray(data))      extracted = data;
//       else if (data.extracted_data)      extracted = data.extracted_data;

//       const flat     = flattenExtracted(extracted);
//       const editRows = flat.map(buildEditRow);

//       setExtractedRows(flat);
//       setEditedRows(editRows);
//       setSelectedIdx(0);
//       if (onUploadComplete) onUploadComplete(editRows.map((r) => r.invoice_number).filter(Boolean));

//       const initial = flat.map(() => ({ loading:true, success:null, error:null, showEdit:false, emailSt:null }));
//       setPushStates(initial);
//       setStep(1);
//       flat.forEach((_, i) => doPush(i, editRows));
//     } catch (err) {
//       setUploadError(err.message); setUploadStage('idle');
//     } finally {
//       setUploading(false);
//     }
//   }, [files, onUploadComplete, doPush]);

//   const updateField    = (idx, field, val) =>
//     setEditedRows((p) => { const c=[...p]; c[idx]={...c[idx],[field]:val}; return c; });
//   const toggleShowEdit = (idx) =>
//     setPushStates((p) => { const c=[...p]; c[idx]={...c[idx],showEdit:!c[idx].showEdit}; return c; });

//   // ── Send email ────────────────────────────────────────────────────────────
//   const handleSendEmail = async (idx) => {
//     const email = localStorage.getItem('userEmail') || '';
//     if (!email) { setPushStates((p)=>{ const c=[...p]; c[idx]={...c[idx],emailSt:{error:'No email found.'}}; return c; }); return; }
//     setPushStates((p)=>{ const c=[...p]; c[idx]={...c[idx],emailSt:{loading:true}}; return c; });
//     try {
//       const body = { recipient:email, sap_payload_list: extractedRows.map((inv)=>({ extracted_data:[inv], document_file_path:'Uploaded via web interface', document_type:'PDF' })) };
//       const res  = await fetch('https://ocrtool.savictech.com/api/invoice/send_email', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body) });
//       const d    = await res.json();
//       if (!res.ok) throw new Error(d?.message||`HTTP ${res.status}`);
//       setPushStates((p)=>{ const c=[...p]; c[idx]={...c[idx],emailSt:{success:d?.message||`Sent to ${email}`}}; return c; });
//     } catch (err) {
//       setPushStates((p)=>{ const c=[...p]; c[idx]={...c[idx],emailSt:{error:err.message}}; return c; });
//     }
//   };

//   // ── Export Excel ──────────────────────────────────────────────────────────
//   const handleExportExcel = async () => {
//     try {
//       const body = { sap_payload_list: extractedRows.map((inv)=>({ extracted_data:[inv], document_file_path:'Uploaded via web interface', document_type:'PDF' })) };
//       const res  = await fetch('https://ocrtool.savictech.com/api/export-invoices-excel', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body) });
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const blob = await res.blob();
//       const url  = window.URL.createObjectURL(blob);
//       const a    = document.createElement('a');
//       a.href = url;
//       const m = (res.headers.get('content-disposition')||'').match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
//       a.setAttribute('download', m ? m[1].replace(/['"]/g,'') : 'SAP_Invoices.xlsx');
//       document.body.appendChild(a); a.click(); document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);
//     } catch (err) { alert(`Export failed: ${err.message}`); }
//   };

//   const handleReset = () => {
//     setStep(0); setFiles([]); setExtractedRows([]); setEditedRows([]);
//     setPushStates([]); setUploadStage('idle'); setSelectedIdx(0);
//   };

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <div>
//       {/* Step indicator */}
//       {(() => {
//         const STEP_META = [
//           { icon: <FiUpload size={22}/>,      desc: 'Select & upload invoice files'       },
//           { icon: <FiZap    size={22}/>,      desc: 'Auto-push to SAP · fix if failed'    },
//         ];
//         return (
//           <div style={{
//             display: 'flex', alignItems: 'center',
//             background: 'linear-gradient(135deg,rgba(255,255,255,.92) 0%,rgba(239,246,255,.85) 100%)',
//             border: '1px solid rgba(216,227,240,.9)',
//             borderRadius: 22,
//             padding: '18px 28px',
//             marginBottom: 24,
//             boxShadow: '0 4px 24px rgba(12,28,52,.09)',
//             backdropFilter: 'blur(14px)',
//             position: 'relative', overflow: 'hidden',
//             gap: 0,
//           }}>
//             {/* Top gradient accent bar */}
//             <div style={{
//               position:'absolute', top:0, left:0, right:0, height:3,
//               background: step >= 1
//                 ? 'linear-gradient(90deg,#059669 0%,#16a34a 100%)'
//                 : 'linear-gradient(90deg,#0f4c81 0%,#147699 50%,rgba(216,227,240,.5) 100%)',
//               borderRadius:'22px 22px 0 0',
//               transition:'background .4s',
//             }}/>

//             {STEPS.map((label, i) => {
//               const isDone   = i < step;
//               const isActive = i === step;
//               return (
//                 <React.Fragment key={label}>
//                   {/* Step item — flexShrink:0 so it stays compact */}
//                   <div style={{ display:'flex', alignItems:'center', gap:12, flexShrink:0 }}>
//                     {/* Circle */}
//                     <div style={{
//                       width:48, height:48, borderRadius:'50%', flexShrink:0,
//                       display:'flex', alignItems:'center', justifyContent:'center',
//                       background: isDone
//                         ? 'linear-gradient(135deg,#059669,#047857)'
//                         : isActive
//                           ? 'linear-gradient(135deg,#0f4c81,#147699)'
//                           : 'rgba(216,227,240,.55)',
//                       color: isDone || isActive ? '#fff' : '#9ab0c8',
//                       boxShadow: isDone
//                         ? '0 4px 16px rgba(5,150,105,.4)'
//                         : isActive
//                           ? '0 4px 18px rgba(15,76,129,.42)'
//                           : 'none',
//                       border: isDone || isActive ? 'none' : '2px solid rgba(216,227,240,.9)',
//                       transition: 'all .3s ease',
//                     }}>
//                       {isDone ? <FiCheckCircle size={20}/> : STEP_META[i].icon}
//                     </div>

//                     {/* Text */}
//                     <div>
//                       <div style={{
//                         fontSize:'0.88rem', fontWeight:800,
//                         fontFamily:"'Space Grotesk',sans-serif",
//                         color: isDone ? '#059669' : isActive ? '#0f4c81' : '#b0bec5',
//                         marginBottom:2, transition:'color .3s', whiteSpace:'nowrap',
//                       }}>{label}</div>
//                       <div style={{
//                         fontSize:'0.71rem', fontWeight:500, whiteSpace:'nowrap',
//                         color: isDone ? 'rgba(5,150,105,.72)' : isActive ? '#4a6080' : '#c4d0dc',
//                         transition:'color .3s',
//                       }}>{STEP_META[i].desc}</div>
//                     </div>
//                   </div>

//                   {/* Connector — flex:1 fills all remaining space */}
//                   {i < STEPS.length - 1 && (
//                     <div style={{
//                       flex:1, minWidth:40, display:'flex', alignItems:'center',
//                       margin:'0 16px', position:'relative',
//                     }}>
//                       <div style={{
//                         flex:1, height:4, borderRadius:4,
//                         background: isDone
//                           ? 'linear-gradient(90deg,#059669,#4ade80)'
//                           : 'rgba(216,227,240,.7)',
//                         transition:'background .4s', position:'relative',
//                       }}>
//                         {isDone && (
//                           <div style={{
//                             position:'absolute', right:-5, top:'50%',
//                             transform:'translateY(-50%)',
//                             width:10, height:10, borderRadius:'50%',
//                             background:'#4ade80',
//                             boxShadow:'0 0 0 4px rgba(74,222,128,.22)',
//                           }}/>
//                         )}
//                       </div>
//                     </div>
//                   )}
//                 </React.Fragment>
//               );
//             })}

//             {/* Progress pill */}
//             <div style={{
//               marginLeft:16, padding:'6px 18px', flexShrink:0,
//               background: step >= STEPS.length - 1
//                 ? 'linear-gradient(135deg,rgba(5,150,105,.12),rgba(16,185,129,.08))'
//                 : 'rgba(15,76,129,.08)',
//               border:`1px solid ${step >= STEPS.length - 1 ? 'rgba(5,150,105,.25)' : 'rgba(15,76,129,.18)'}`,
//               borderRadius:999,
//               fontSize:'0.72rem', fontWeight:800,
//               color: step >= STEPS.length - 1 ? '#059669' : '#0f4c81',
//               transition:'all .3s',
//             }}>
//               Step {step + 1} / {STEPS.length}
//             </div>
//           </div>
//         );
//       })()}

//       {/* ══════════════════════════════════════════════════
//           STEP 1 — UPLOAD
//       ══════════════════════════════════════════════════ */}
//       {step === 0 && (
//         <div className="inv-card">
//           {/* Drop zone */}
//           <div
//             className={`inv-drop-zone${dragOver ? ' drag-over' : ''}`}
//             style={{ padding:'60px 24px' }}
//             onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
//             onDragLeave={() => setDragOver(false)}
//             onDrop={handleDrop}
//             onClick={() => !uploading && fileRef.current?.click()}
//           >
//             <div style={{
//               width:80, height:80, borderRadius:24,
//               background: dragOver ? 'linear-gradient(135deg,#147699,#0f4c81)' : 'linear-gradient(135deg,#0f4c81,#147699)',
//               display:'flex', alignItems:'center', justifyContent:'center',
//               margin:'0 auto 20px', color:'#fff',
//               boxShadow: dragOver ? '0 8px 32px rgba(15,76,129,.5)' : '0 6px 24px rgba(15,76,129,.35)',
//               transform: dragOver ? 'scale(1.08)' : 'scale(1)',
//               transition:'all .22s ease',
//             }}>
//               <FiUpload size={34}/>
//             </div>
//             <h4 style={{ fontSize:'1.15rem', fontWeight:800, color:'var(--ink)', margin:'0 0 8px', fontFamily:"'Space Grotesk',sans-serif" }}>
//               {dragOver ? '✦ Release to upload' : 'Drop your invoices here'}
//             </h4>
//             <p style={{ fontSize:'0.85rem', color:'var(--sub)', margin:'0 0 20px' }}>or click to browse · multiple files supported</p>
//             <div style={{ display:'flex', gap:8, justifyContent:'center', flexWrap:'wrap' }}>
//               {['PDF','PNG','JPG','XLSX'].map((t) => (
//                 <span key={t} style={{ padding:'4px 14px', borderRadius:999, background:'rgba(15,76,129,.08)', border:'1px solid rgba(15,76,129,.18)', fontSize:'0.74rem', fontWeight:800, color:'var(--blue-1)', letterSpacing:'0.5px' }}>{t}</span>
//               ))}
//             </div>
//             <input ref={fileRef} type="file" multiple style={{ display:'none' }}
//               accept=".pdf,.png,.jpg,.jpeg,.xlsx,.xls"
//               onChange={(e) => addFiles(e.target.files)}/>
//           </div>

//           {/* File list */}
//           {files.length > 0 && (
//             <div style={{ marginTop:20 }}>
//               <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
//                 <span style={{ fontSize:'0.82rem', fontWeight:700, color:'var(--ink)', display:'flex', alignItems:'center', gap:6 }}>
//                   <FiFile size={14} style={{ color:'var(--blue-1)' }}/> {files.length} file{files.length!==1?'s':''} ready
//                 </span>
//                 <button onClick={() => setFiles([])} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'0.76rem', color:'var(--sub)', fontWeight:600, display:'flex', alignItems:'center', gap:4 }}>
//                   <FiX size={12}/> Clear all
//                 </button>
//               </div>
//               <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
//                 {files.map((f) => {
//                   const ext = f.name.split('.').pop();
//                   return (
//                     <div key={f.name} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 14px', background:'rgba(255,255,255,.85)', border:'1px solid var(--border-lt)', borderRadius:12, gap:12 }}>
//                       <div style={{ display:'flex', alignItems:'center', gap:10, minWidth:0 }}>
//                         <div style={{ width:36, height:36, borderRadius:9, flexShrink:0, background:fileColor(ext), display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:'0.6rem', fontWeight:800 }}>{ext.toUpperCase()}</div>
//                         <div style={{ minWidth:0 }}>
//                           <div style={{ fontSize:'0.84rem', fontWeight:600, color:'var(--ink)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{f.name}</div>
//                           <div style={{ fontSize:'0.7rem', color:'var(--muted)', marginTop:1 }}>{fmtBytes(f.size)}</div>
//                         </div>
//                       </div>
//                       <button onClick={(e)=>{ e.stopPropagation(); removeFile(f.name); }} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--muted)', padding:4, borderRadius:6, display:'flex' }}
//                         onMouseEnter={(e)=>e.currentTarget.style.color='var(--red)'} onMouseLeave={(e)=>e.currentTarget.style.color='var(--muted)'}>
//                         <FiX size={15}/>
//                       </button>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}

//           {/* Upload progress */}
//           {uploading && (
//             <div style={{ marginTop:16, display:'flex', alignItems:'center', gap:12, padding:'12px 18px', background:'linear-gradient(135deg,rgba(239,246,255,.9),rgba(255,244,234,.6))', border:'1px solid var(--blue-3)', borderRadius:12 }}>
//               {[{key:'uploading',label:'Sending files'},{key:'processing',label:'Extracting data'},{key:'done',label:'Complete'}].map((s,i)=>{
//                 const isDone   = uploadStage==='done'||(uploadStage==='processing'&&i===0);
//                 const isActive = uploadStage===s.key;
//                 return (
//                   <React.Fragment key={s.key}>
//                     <div style={{ display:'flex', alignItems:'center', gap:6 }}>
//                       {isActive ? <div className="inv-spinner" style={{ width:13, height:13, borderWidth:2 }}/>
//                         : <div style={{ width:13, height:13, borderRadius:'50%', background:isDone?'var(--green)':'var(--border)', flexShrink:0 }}/>}
//                       <span style={{ fontSize:'0.8rem', fontWeight:isActive||isDone?700:400, color:isActive?'var(--blue-1)':isDone?'var(--green)':'var(--muted)', whiteSpace:'nowrap' }}>
//                         {s.label}{isActive?'…':''}
//                       </span>
//                     </div>
//                     {i<2 && <div style={{ flex:1, height:2, background:isDone?'var(--green)':'var(--border)', borderRadius:2, transition:'background .4s' }}/>}
//                   </React.Fragment>
//                 );
//               })}
//             </div>
//           )}

//           {uploadError && <div className="inv-error-banner" style={{ marginTop:12 }}><FiAlertCircle size={14}/> {uploadError}</div>}

//           {/* CTA */}
//           <div style={{ marginTop:24 }}>
//             <button className="inv-btn primary"
//               style={{ width:'100%', justifyContent:'center', padding:'13px 24px', fontSize:'0.95rem', borderRadius:14 }}
//               onClick={handleUpload} disabled={!files.length||uploading}>
//               {uploading
//                 ? <><div className="inv-spinner"/>Processing {files.length} file{files.length!==1?'s':''}…</>
//                 : <><FiZap size={16}/>{files.length>0?`Extract & Push ${files.length} Invoice${files.length!==1?'s':''} to SAP`:'Extract & Push to SAP'}</>
//               }
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ══════════════════════════════════════════════════
//           STEP 2 — REVIEW & PUSH  (Master-Detail)
//       ══════════════════════════════════════════════════ */}
//       {step === 1 && (
//         <div style={{ display:'flex', flexDirection:'column', gap:14 }}>

//           {/* Summary counters */}
//           <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
//             {[
//               { label:'Total',       val:extractedRows.length,                   color:'#0369a1', bg:'#e0f2fe', border:'#bae6fd', Icon:FiFile },
//               { label:'Pushed',      val:pushStates.filter(s=>s.success).length, color:'#065f46', bg:'#d1fae5', border:'#6ee7b7', Icon:FiCheckCircle },
//               { label:'Failed',      val:pushStates.filter(s=>s.error).length,   color:pushStates.some(s=>s.error)?'#b91c1c':'#64748b', bg:pushStates.some(s=>s.error)?'#fee2e2':'#f8fafc', border:pushStates.some(s=>s.error)?'#fca5a5':'#e2e8f0', Icon:FiAlertCircle },
//               { label:'In Progress', val:pushStates.filter(s=>s.loading).length, color:'#92400e', bg:'#fef3c7', border:'#fde68a', Icon:FiZap },
//             ].map(({ label, val, color, bg, border, Icon }) => (
//               <div key={label} style={{ display:'flex', alignItems:'center', gap:10, background:bg, border:`1px solid ${border}`, borderRadius:12, padding:'10px 16px', minWidth:110 }}>
//                 <div style={{ width:34, height:34, borderRadius:8, background:color, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><Icon size={16} color="#fff"/></div>
//                 <div>
//                   <div style={{ fontSize:'0.63rem', fontWeight:700, color, textTransform:'uppercase', letterSpacing:'0.5px' }}>{label}</div>
//                   <div style={{ fontSize:'1.4rem', fontWeight:900, color, lineHeight:1.1 }}>{val}</div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* ── Master-Detail layout ── */}
//           <div style={{ display:'flex', gap:14, alignItems:'flex-start' }}>

//             {/* LEFT — invoice list (sticky sidebar) */}
//             <div style={{
//               width:264, flexShrink:0, display:'flex', flexDirection:'column',
//               background:'rgba(255,255,255,.88)', border:'1px solid rgba(216,227,240,.8)',
//               borderRadius:18, overflow:'hidden', boxShadow:'0 2px 14px rgba(12,28,52,.07)',
//               position:'sticky', top:16,
//               maxHeight:'calc(100vh - 200px)',
//             }}>
//               {/* List header */}
//               <div style={{ padding:'13px 16px', background:'linear-gradient(135deg,rgba(239,246,255,.95),rgba(255,244,234,.5))', borderBottom:'1px solid rgba(216,227,240,.5)', flexShrink:0 }}>
//                 <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontWeight:800, fontSize:'0.85rem', color:'#0f4c81', display:'flex', alignItems:'center', gap:8 }}>
//                   Invoices
//                   <span style={{ background:'linear-gradient(135deg,#e56e11,#fb923c)', color:'#fff', fontSize:'0.63rem', fontWeight:800, padding:'1px 7px', borderRadius:999 }}>
//                     {editedRows.length}
//                   </span>
//                 </div>
//                 <div style={{ fontSize:'0.67rem', color:'#7a96b2', marginTop:2 }}>
//                   {pushStates.filter(s=>s.success).length} pushed · {pushStates.filter(s=>s.error).length} failed · {pushStates.filter(s=>s.loading).length} in progress
//                 </div>
//               </div>

//               {/* Scrollable rows */}
//               <div style={{ flex:1, overflowY:'auto' }}>
//                 {editedRows.map((row, idx) => {
//                   const ps = pushStates[idx] || {};
//                   const isSel = idx === selectedIdx;
//                   const accent = ps.loading ? '#2563eb' : ps.success ? '#059669' : ps.error ? '#dc2626' : '#94a3b8';
//                   const statusLabel = ps.loading ? 'Pushing…' : ps.success ? 'Pushed' : ps.error ? 'Failed' : 'Pending';
//                   const pillBg      = ps.loading?'#dbeafe':ps.success?'#d1fae5':ps.error?'#fee2e2':'#f1f5f9';
//                   const pillColor   = ps.loading?'#1e40af':ps.success?'#065f46':ps.error?'#991b1b':'#475569';
//                   return (
//                     <div
//                       key={idx}
//                       onClick={() => setSelectedIdx(idx)}
//                       style={{
//                         padding:'11px 14px 11px 0',
//                         borderBottom:'1px solid rgba(216,227,240,.3)',
//                         cursor:'pointer', transition:'background .12s',
//                         background: isSel
//                           ? ps.error?'linear-gradient(90deg,rgba(254,226,226,.6),rgba(255,241,242,.3))':ps.success?'linear-gradient(90deg,rgba(209,250,229,.6),rgba(240,253,244,.3))':'linear-gradient(90deg,rgba(219,234,254,.6),rgba(239,246,255,.3))'
//                           : 'transparent',
//                         display:'flex', alignItems:'stretch', gap:0,
//                       }}
//                       onMouseEnter={(e) => { if (!isSel) e.currentTarget.style.background = 'rgba(239,246,255,.5)'; }}
//                       onMouseLeave={(e) => { if (!isSel) e.currentTarget.style.background = 'transparent'; }}
//                     >
//                       {/* Left accent bar */}
//                       <div style={{ width:4, flexShrink:0, borderRadius:'0 3px 3px 0', background: isSel ? accent : 'transparent', marginRight:12, transition:'background .15s' }}/>
//                       <div style={{ flex:1, minWidth:0 }}>
//                         <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:6, marginBottom:4 }}>
//                           <span style={{ fontSize:'0.8rem', fontWeight:800, color: isSel ? accent : '#1e293b', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', flex:1 }}>
//                             {row._originalInvoiceNumber || row.invoice_number || `Invoice ${idx+1}`}
//                           </span>
//                           <span style={{ fontSize:'0.62rem', fontWeight:800, padding:'2px 7px', borderRadius:999, background:pillBg, color:pillColor, flexShrink:0, display:'flex', alignItems:'center', gap:3 }}>
//                             {ps.loading && <div className="inv-spinner" style={{ width:8, height:8, borderWidth:1.5, color:pillColor }}/>}
//                             {statusLabel}
//                           </span>
//                         </div>
//                         {(row.invoice_date || row.invoice_total) && (
//                           <div style={{ fontSize:'0.66rem', color:'#94a3b8', fontWeight:500 }}>
//                             {row.invoice_date}{row.invoice_date && row.invoice_total ? ' · ' : ''}{row.invoice_total}
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>

//               {/* Footer */}
//               <div style={{ padding:'10px 14px', borderTop:'1px solid rgba(216,227,240,.5)', flexShrink:0, background:'rgba(248,250,252,.8)' }}>
//                 <button className="inv-btn secondary" onClick={handleReset} style={{ width:'100%', justifyContent:'center', fontSize:'0.75rem', padding:'7px 10px' }}>
//                   <FiRefreshCw size={12}/> Upload More
//                 </button>
//               </div>
//             </div>

//             {/* RIGHT — detail panel */}
//             {(() => {
//               const idx       = selectedIdx;
//               const row       = editedRows[idx];
//               const ps        = pushStates[idx] || {};
//               const cfg       = statusCfg(ps);
//               const curInv    = extractedRows[idx];
//               const lineItems    = curInv?._items || [];
//               const lineItemKeys = lineItems.length > 0 ? Object.keys(lineItems[0]) : [];

//               if (!row) return (
//                 <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', color:'var(--muted)', fontSize:'0.85rem' }}>
//                   Select an invoice from the list
//                 </div>
//               );

//               return (
//                 <div style={{ flex:1, minWidth:0 }}>
//                   <div style={{
//                     background:'rgba(255,255,255,.95)',
//                     border:`1px solid ${cfg.border}`,
//                     borderRadius:20, overflow:'hidden',
//                     boxShadow:'0 4px 24px rgba(12,28,52,.10)',
//                   }}>

//                     {/* ── Colored header band ── */}
//                     <div style={{
//                       background: cfg.bg,
//                       borderBottom:`2px solid ${cfg.border}`,
//                       padding:'20px 24px 16px',
//                     }}>
//                       {/* Top row: icon + title + nav */}
//                       <div style={{ display:'flex', alignItems:'center', gap:14 }}>
//                         {/* Status icon */}
//                         <div style={{
//                           width:52, height:52, borderRadius:14, flexShrink:0,
//                           background: ps.loading?'linear-gradient(135deg,#2563eb,#1d4ed8)':ps.success?'linear-gradient(135deg,#059669,#047857)':ps.error?'linear-gradient(135deg,#dc2626,#b91c1c)':'linear-gradient(135deg,#0f4c81,#147699)',
//                           display:'flex', alignItems:'center', justifyContent:'center', color:'#fff',
//                           boxShadow: ps.success?'0 6px 20px rgba(5,150,105,.4)':ps.error?'0 6px 20px rgba(220,38,38,.4)':'0 6px 20px rgba(37,99,235,.4)',
//                         }}>
//                           {ps.loading ? <div className="inv-spinner" style={{ width:24, height:24, borderWidth:2.5 }}/>
//                             : ps.success ? <FiCheckCircle size={24}/>
//                             : ps.error   ? <FiAlertCircle size={24}/>
//                             : <FiZap size={24}/>}
//                         </div>

//                         {/* Invoice number + status pill */}
//                         <div style={{ flex:1, minWidth:0 }}>
//                           <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap', marginBottom:5 }}>
//                             <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontWeight:900, fontSize:'1.18rem', color:'#0f1f35', letterSpacing:'-0.02em' }}>
//                               {row._originalInvoiceNumber || row.invoice_number || `Invoice ${idx+1}`}
//                             </span>
//                             <span style={{ padding:'4px 12px', borderRadius:999, fontSize:'0.71rem', fontWeight:800, background:cfg.pillBg, color:cfg.pillColor, border:`1px solid ${cfg.pillBorder}`, display:'flex', alignItems:'center', gap:5 }}>
//                               {ps.loading && <div className="inv-spinner" style={{ width:9, height:9, borderWidth:1.5, color:cfg.pillColor }}/>}
//                               {cfg.label}
//                             </span>
//                           </div>
//                           {/* Info chips */}
//                           <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
//                             {[
//                               row.invoice_date         && { label:'Date',  value:row.invoice_date },
//                               row.purchase_order_number && { label:'PO',    value:row.purchase_order_number, mono:true },
//                               row.invoice_total         && { label:'Total', value:row.invoice_total, bold:true },
//                             ].filter(Boolean).map(chip => (
//                               <div key={chip.label} style={{ display:'flex', alignItems:'center', gap:4, padding:'3px 10px', borderRadius:8, background:'rgba(255,255,255,.65)', border:'1px solid rgba(216,227,240,.7)', fontSize:'0.76rem' }}>
//                                 <span style={{ fontSize:'0.6rem', fontWeight:800, color:'#7a96b2', textTransform:'uppercase', letterSpacing:'0.4px' }}>{chip.label}</span>
//                                 <span style={{ fontWeight: chip.bold?800:700, color:'#12213a', fontFamily: chip.mono?'monospace':'inherit' }}>{chip.value}</span>
//                               </div>
//                             ))}
//                           </div>
//                         </div>

//                         {/* Prev / Next */}
//                         <div style={{ display:'flex', alignItems:'center', gap:8, flexShrink:0 }}>
//                           <button onClick={() => setSelectedIdx(i => Math.max(0, i-1))} disabled={selectedIdx===0}
//                             style={{ width:34, height:34, borderRadius:10, border:'1px solid rgba(216,227,240,.9)', background:'rgba(255,255,255,.85)', cursor:selectedIdx===0?'default':'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'#4a6080', fontSize:'1rem', opacity:selectedIdx===0?.35:1, transition:'all .15s' }}
//                             onMouseEnter={(e)=>{ if(selectedIdx>0){ e.currentTarget.style.background='#fff'; e.currentTarget.style.borderColor='#0f4c81'; e.currentTarget.style.color='#0f4c81'; }}}
//                             onMouseLeave={(e)=>{ e.currentTarget.style.background='rgba(255,255,255,.85)'; e.currentTarget.style.borderColor='rgba(216,227,240,.9)'; e.currentTarget.style.color='#4a6080'; }}>
//                             ‹
//                           </button>
//                           <span style={{ fontSize:'0.72rem', fontWeight:700, color:'#7a96b2', minWidth:36, textAlign:'center' }}>{idx+1} / {editedRows.length}</span>
//                           <button onClick={() => setSelectedIdx(i => Math.min(editedRows.length-1, i+1))} disabled={selectedIdx===editedRows.length-1}
//                             style={{ width:34, height:34, borderRadius:10, border:'1px solid rgba(216,227,240,.9)', background:'rgba(255,255,255,.85)', cursor:selectedIdx===editedRows.length-1?'default':'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'#4a6080', fontSize:'1rem', opacity:selectedIdx===editedRows.length-1?.35:1, transition:'all .15s' }}
//                             onMouseEnter={(e)=>{ if(selectedIdx<editedRows.length-1){ e.currentTarget.style.background='#fff'; e.currentTarget.style.borderColor='#0f4c81'; e.currentTarget.style.color='#0f4c81'; }}}
//                             onMouseLeave={(e)=>{ e.currentTarget.style.background='rgba(255,255,255,.85)'; e.currentTarget.style.borderColor='rgba(216,227,240,.9)'; e.currentTarget.style.color='#4a6080'; }}>
//                             ›
//                           </button>
//                         </div>
//                       </div>

//                       {/* SAP status message inside header */}
//                       {(ps.success || ps.error) && (
//                         <div style={{ marginTop:14, padding:'10px 14px', borderRadius:10, background:ps.success?'rgba(5,150,105,.1)':'rgba(220,38,38,.08)', border:`1px solid ${ps.success?'rgba(5,150,105,.25)':'rgba(220,38,38,.22)'}`, display:'flex', alignItems:'center', gap:8 }}>
//                           {ps.success
//                             ? <><FiCheckCircle size={14} style={{ color:'#059669', flexShrink:0 }}/><span style={{ fontSize:'0.83rem', fontWeight:600, color:'#065f46' }}>{ps.success}</span></>
//                             : <><FiAlertCircle size={14} style={{ color:'#dc2626', flexShrink:0 }}/><span style={{ fontSize:'0.83rem', fontWeight:600, color:'#991b1b', flex:1 }}>{ps.error}</span></>
//                           }
//                         </div>
//                       )}
//                     </div>

//                     {/* Extracted fields */}
//                     {curInv && displayKeys(curInv).length > 0 && (
//                       <div style={{ padding:'0 20px' }}>
//                         <Divider label="Extracted Fields"/>
//                         <div className="inv-extracted-grid" style={{ marginBottom:0 }}>
//                           {displayKeys(curInv).map((key) =>
//                             curInv[key]!=null && curInv[key]!=='' ? (
//                               <div key={key} className="inv-extracted-kv">
//                                 <div className="kv-label">{key}</div>
//                                 <div className="kv-value" title={String(curInv[key])}>{String(curInv[key])}</div>
//                               </div>
//                             ) : null
//                           )}
//                         </div>
//                       </div>
//                     )}

//                     {/* Line items */}
//                     {lineItems.length > 0 && (
//                       <div style={{ padding:'0 20px' }}>
//                         <Divider label={`Line Items (${lineItems.length})`}/>
//                         <div style={{ borderRadius:12, overflow:'hidden', border:'1px solid rgba(216,227,240,.7)', marginBottom:4 }}>
//                           <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.82rem' }}>
//                             <thead>
//                               <tr>
//                                 <th style={{ padding:'10px 14px', background:'linear-gradient(135deg,rgba(239,246,255,.95),rgba(255,244,234,.4))', color:'var(--blue-1)', fontWeight:800, textAlign:'left', borderBottom:'2px solid var(--blue-3)', fontSize:'0.72rem', whiteSpace:'nowrap' }}>#</th>
//                                 {lineItemKeys.map((k) => (
//                                   <th key={k} style={{ padding:'10px 14px', background:'linear-gradient(135deg,rgba(239,246,255,.95),rgba(255,244,234,.4))', color:'var(--blue-1)', fontWeight:800, textAlign:'left', borderBottom:'2px solid var(--blue-3)', fontSize:'0.72rem', whiteSpace:'nowrap' }}>{k}</th>
//                                 ))}
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {lineItems.map((item, li) => (
//                                 <tr key={li} style={{ background: li%2===0?'rgba(255,255,255,.7)':'rgba(239,246,255,.3)' }}
//                                   onMouseEnter={(e)=>e.currentTarget.style.background='rgba(219,234,254,.35)'}
//                                   onMouseLeave={(e)=>e.currentTarget.style.background=li%2===0?'rgba(255,255,255,.7)':'rgba(239,246,255,.3)'}>
//                                   <td style={{ padding:'9px 14px', borderBottom:'1px solid rgba(216,227,240,.4)', color:'var(--muted)', fontWeight:700, fontSize:'0.75rem' }}>{li+1}</td>
//                                   {lineItemKeys.map((k) => (
//                                     <td key={k} style={{ padding:'9px 14px', borderBottom:'1px solid rgba(216,227,240,.4)', color:'var(--ink)' }}>{String(item[k]??'—')}</td>
//                                   ))}
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     )}

//                     {/* Edit form (on failure) */}
//                     {ps.error && (
//                       <div style={{ padding:'0 20px 4px', marginTop:12 }}>
//                         <button onClick={() => toggleShowEdit(idx)}
//                           style={{ display:'flex', alignItems:'center', gap:6, background:'none', border:'none', cursor:'pointer', fontSize:'0.8rem', fontWeight:700, color:ps.showEdit?'var(--sub)':'var(--blue-1)', padding:'4px 0', marginBottom:ps.showEdit?10:0 }}>
//                           <FiEdit3 size={13}/>
//                           {ps.showEdit ? 'Cancel edit' : 'Edit invoice details & retry'}
//                         </button>
//                         {ps.showEdit && (
//                           <div style={{ background:'rgba(255,255,255,.92)', border:'1px solid var(--border-lt)', borderRadius:14, overflow:'hidden', marginBottom:4 }}>
//                             <div style={{ padding:'12px 18px', background:'linear-gradient(135deg,rgba(239,246,255,.9),rgba(255,244,234,.6))', borderBottom:'1px solid var(--border-lt)', display:'flex', alignItems:'center', gap:8 }}>
//                               <FiEdit3 size={14} style={{ color:'var(--blue-1)' }}/>
//                               <span style={{ fontWeight:700, fontSize:'0.84rem', color:'var(--ink)' }}>Fix & Retry</span>
//                               <span style={{ fontSize:'0.74rem', color:'var(--sub)' }}>Update fields below and push again</span>
//                             </div>
//                             <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, padding:'16px 18px' }}>
//                               {[
//                                 { field:'invoice_number',        label:'Invoice Number', type:'text',  placeholder:'e.g. INV-2024-001' },
//                                 { field:'invoice_date',          label:'Invoice Date',   type:'date',  placeholder:'' },
//                                 { field:'invoice_total',         label:'Total Amount',   type:'text',  placeholder:'e.g. 12500' },
//                                 { field:'purchase_order_number', label:'PO Number',      type:'text',  placeholder:'e.g. PO-456' },
//                                 { field:'ap_processor',          label:'AP Processor',   type:'email', placeholder:'user@company.com' },
//                               ].map(({ field, label, type, placeholder }) => (
//                                 <div key={field} style={{ display:'flex', flexDirection:'column', gap:5 }}>
//                                   <label style={{ fontSize:'0.68rem', fontWeight:800, color:'var(--sub)', textTransform:'uppercase', letterSpacing:'0.5px' }}>{label}</label>
//                                   <input type={type} value={row[field]||''} onChange={(e)=>updateField(idx,field,e.target.value)} placeholder={placeholder}
//                                     style={{ padding:'9px 12px', border:'1.5px solid var(--border)', borderRadius:9, fontSize:'0.85rem', color:'var(--ink)', fontFamily:'inherit', background:'rgba(255,255,255,.85)', outline:'none', transition:'border .18s' }}
//                                     onFocus={(e)=>{ e.target.style.borderColor='var(--o2c-teal)'; e.target.style.boxShadow='0 0 0 3px rgba(20,118,153,.1)'; }}
//                                     onBlur={(e) =>{ e.target.style.borderColor='var(--border)';    e.target.style.boxShadow='none'; }}/>
//                                 </div>
//                               ))}
//                             </div>
//                             <div style={{ padding:'0 18px 18px' }}>
//                               <button className="inv-btn primary" style={{ width:'100%', justifyContent:'center', padding:'12px', fontSize:'0.9rem', borderRadius:12 }}
//                                 onClick={() => doPush(idx, editedRows)} disabled={ps.loading}>
//                                 {ps.loading ? <><div className="inv-spinner"/>Pushing…</> : <><FiZap size={15}/>Save & Push to SAP</>}
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Actions bar */}
//                     <div style={{ padding:'12px 20px 16px', marginTop:14, borderTop:'1px solid rgba(216,227,240,.45)', display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', background:'rgba(248,250,252,.6)' }}>
//                       <div style={{ display:'flex', gap:6, flex:1, flexWrap:'wrap' }}>
//                         {ps.emailSt?.success
//                           ? <span style={{ display:'flex', alignItems:'center', gap:5, fontSize:'0.8rem', color:'var(--green)', fontWeight:600 }}><FiCheckCircle size={13}/> {ps.emailSt.success}</span>
//                           : <button className="inv-btn ghost" style={{ fontSize:'0.8rem', padding:'6px 14px' }} onClick={() => handleSendEmail(idx)} disabled={ps.emailSt?.loading}>
//                               {ps.emailSt?.loading ? <><div className="inv-spinner"/>Sending…</> : <><FiMail size={13}/>Send Email</>}
//                             </button>
//                         }
//                         {ps.emailSt?.error && <span style={{ fontSize:'0.75rem', color:'var(--red)', alignSelf:'center' }}>{ps.emailSt.error}</span>}
//                         <button className="inv-btn ghost" style={{ fontSize:'0.8rem', padding:'6px 14px' }} onClick={handleExportExcel}>
//                           <FiDownload size={13}/> Export Excel
//                         </button>
//                       </div>
//                       {ps.error && !ps.showEdit && (
//                         <button className="inv-btn primary" style={{ fontSize:'0.8rem', padding:'6px 16px' }} onClick={() => doPush(idx, editedRows)} disabled={ps.loading}>
//                           <FiZap size={12}/> Retry Push
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })()}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OCRProcess;


import React, { useState, useRef, useCallback } from 'react';
import {
  FiUpload, FiEdit3, FiZap, FiCheckCircle, FiMail, FiDownload,
  FiX, FiFile, FiAlertCircle, FiRefreshCw,
} from 'react-icons/fi';
import { uploadInvoice, saveInvoiceReview, pushInvoiceToSap } from '../../utils/ocrApi';

const STEPS = ['Upload Invoices', 'Review & Push'];

// ── Helpers ───────────────────────────────────────────────────────────────────
function flattenExtracted(extractedData) {
  const rows = [];
  if (!Array.isArray(extractedData)) return rows;
  extractedData.forEach((arr, ii) => {
    if (Array.isArray(arr)) {
      arr.forEach((inv, di) => {
        const { Items, items, ...rest } = inv;
        rows.push({ ...rest, _items: Items || items || [], _id: `${ii}-${di}` });
      });
    }
  });
  return rows;
}

function buildEditRow(inv) {
  const invoiceNumber =
    inv['Invoice Number'] || inv['invoice_number'] || inv['InvoiceNumber'] || '';
  return {
    invoice_number:         invoiceNumber,
    _originalInvoiceNumber: invoiceNumber,
    invoice_date:           inv['Invoice Date']  || inv['invoice_date']          || inv['Date']         || '',
    invoice_total:          inv['Invoice Total'] || inv['invoice_total']         || inv['Total Amount'] || inv['Total'] || '',
    purchase_order_number:  inv['PO Number']     || inv['purchase_order_number'] || inv['PO No']        || '',
    ap_processor:           inv['AP Processor']  || inv['ap_processor']          || localStorage.getItem('userEmail') || '',
  };
}

function displayKeys(inv) {
  return Object.keys(inv).filter((k) => !k.startsWith('_'));
}

const EXT_COLORS = { pdf:'#e53e3e', png:'#6b46c1', jpg:'#6b46c1', jpeg:'#6b46c1', xlsx:'#2f855a', xls:'#2f855a' };
const fileColor  = (ext) => EXT_COLORS[ext.toLowerCase()] || '#4a5568';
const fmtBytes   = (b)   => b<1024?`${b} B`:b<1048576?`${(b/1024).toFixed(1)} KB`:`${(b/1048576).toFixed(1)} MB`;

function statusCfg(ps) {
  if (ps.loading) return { border:'#93c5fd', bg:'rgba(239,246,255,.55)', accent:'#2563eb', pillBg:'#dbeafe', pillColor:'#1e40af', pillBorder:'#bfdbfe', label:'Pushing…' };
  if (ps.success) return { border:'#6ee7b7', bg:'rgba(236,253,245,.65)', accent:'#059669', pillBg:'#d1fae5', pillColor:'#065f46', pillBorder:'#a7f3d0', label:'Pushed ✓' };
  if (ps.error)   return { border:'#fca5a5', bg:'rgba(255,241,242,.65)', accent:'#dc2626', pillBg:'#fee2e2', pillColor:'#991b1b', pillBorder:'#fca5a5', label:'Failed' };
  return             { border:'var(--border)', bg:'rgba(255,255,255,.7)', accent:'var(--blue-1)', pillBg:'#f1f5f9', pillColor:'#475569', pillBorder:'#e2e8f0', label:'Pending' };
}

// ── Divider ───────────────────────────────────────────────────────────────────
const Divider = ({ label }) => (
  <div style={{ display:'flex', alignItems:'center', gap:10, margin:'16px 0 12px' }}>
    <div style={{ flex:1, height:1, background:'rgba(216,227,240,.6)' }}/>
    <span style={{ fontSize:'0.65rem', fontWeight:800, color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.8px', whiteSpace:'nowrap' }}>{label}</span>
    <div style={{ flex:1, height:1, background:'rgba(216,227,240,.6)' }}/>
  </div>
);

// ── Main Component ────────────────────────────────────────────────────────────
const OCRProcess = ({ onUploadComplete, onPushSuccess }) => {
  const [step,        setStep]        = useState(0);
  const [dragOver,    setDragOver]    = useState(false);
  const [files,       setFiles]       = useState([]);
  const [uploading,   setUploading]   = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [uploadStage, setUploadStage] = useState('idle');

  const [extractedRows, setExtractedRows] = useState([]);
  const [editedRows,    setEditedRows]    = useState([]);
  const [pushStates,    setPushStates]    = useState([]);
  const [selectedIdx,   setSelectedIdx]   = useState(0);

  const fileRef = useRef(null);

  // ── File management ───────────────────────────────────────────────────────
  const addFiles = (incoming) => {
    if (!incoming?.length) return;
    setUploadError('');
    setFiles((prev) => {
      const existing = new Set(prev.map((f) => f.name));
      return [...prev, ...Array.from(incoming).filter((f) => !existing.has(f.name))];
    });
  };
  const removeFile = (name) => setFiles((p) => p.filter((f) => f.name !== name));
  const handleDrop  = (e)    => { e.preventDefault(); setDragOver(false); addFiles(e.dataTransfer.files); };

  // ── Push ──────────────────────────────────────────────────────────────────
  const doPush = useCallback(async (idx, rows) => {
    const row = rows[idx];
    const orig = row._originalInvoiceNumber || row.invoice_number;

    setPushStates((p) => { const c=[...p]; c[idx]={...c[idx], loading:true, error:null}; return c; });

    try {
      let pushNum = orig;
      if (row.invoice_number !== orig) {
        await saveInvoiceReview(orig, row);
        pushNum = row.invoice_number;
        setEditedRows((p) => { const c=[...p]; c[idx]={...c[idx], _originalInvoiceNumber:row.invoice_number}; return c; });
      }

      const d             = await pushInvoiceToSap(pushNum, row.ap_processor);
      const explicitOk    = d?.success === true || d?.status === 'success' || d?.status === 'ok';
      const failed        = !explicitOk && (d?.success === false || d?.status === 'error' || /failed|error|not found/i.test(d?.message || ''));

      setPushStates((p) => {
        const c=[...p];
        c[idx] = failed
          ? { ...c[idx], loading:false, success:null, error:d?.message||'Push to SAP failed.', showEdit:true }
          : { ...c[idx], loading:false, success:d?.message||'Pushed to SAP successfully.', error:null, showEdit:false };
        return c;
      });
      if (!failed && onPushSuccess) onPushSuccess();
    } catch (err) {
      const alreadyPushed = /status is ['"]?success['"]?/i.test(err.message);
      if (alreadyPushed) {
        setPushStates((p) => { const c=[...p]; c[idx]={...c[idx], loading:false, success:'Already pushed to SAP successfully.', error:null, showEdit:false}; return c; });
        if (onPushSuccess) onPushSuccess();
      } else {
        setPushStates((p) => { const c=[...p]; c[idx]={...c[idx], loading:false, success:null, error:err.message, showEdit:true}; return c; });
      }
    }
  }, [onPushSuccess]);

  // ── Upload ────────────────────────────────────────────────────────────────
  const handleUpload = useCallback(async () => {
    if (!files.length) return;
    setUploading(true); setUploadError(''); setUploadStage('uploading');
    try {
      setUploadStage('processing');
      const data = await uploadInvoice(files);
      setUploadStage('done');

      let extracted = [];
      if (data.results?.extracted_data) extracted = data.results.extracted_data;
      else if (Array.isArray(data))      extracted = data;
      else if (data.extracted_data)      extracted = data.extracted_data;

      const flat     = flattenExtracted(extracted);
      const editRows = flat.map(buildEditRow);

      setExtractedRows(flat);
      setEditedRows(editRows);
      setSelectedIdx(0);
      if (onUploadComplete) onUploadComplete(editRows.map((r) => r.invoice_number).filter(Boolean));

      const initial = flat.map(() => ({ loading:true, success:null, error:null, showEdit:false, emailSt:null }));
      setPushStates(initial);
      setStep(1);
      flat.forEach((_, i) => doPush(i, editRows));
    } catch (err) {
      setUploadError(err.message); setUploadStage('idle');
    } finally {
      setUploading(false);
    }
  }, [files, onUploadComplete, doPush]);

  const updateField    = (idx, field, val) =>
    setEditedRows((p) => { const c=[...p]; c[idx]={...c[idx],[field]:val}; return c; });
  const toggleShowEdit = (idx) =>
    setPushStates((p) => { const c=[...p]; c[idx]={...c[idx],showEdit:!c[idx].showEdit}; return c; });

  // ── Send email ────────────────────────────────────────────────────────────
  const handleSendEmail = async (idx) => {
    const email = localStorage.getItem('userEmail') || '';
    if (!email) { setPushStates((p)=>{ const c=[...p]; c[idx]={...c[idx],emailSt:{error:'No email found.'}}; return c; }); return; }
    setPushStates((p)=>{ const c=[...p]; c[idx]={...c[idx],emailSt:{loading:true}}; return c; });
    try {
      const body = { recipient:email, sap_payload_list: extractedRows.map((inv)=>({ extracted_data:[inv], document_file_path:'Uploaded via web interface', document_type:'PDF' })) };
      const res  = await fetch('https://ocrtool.savictech.com/api/invoice/send_email', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body) });
      const d    = await res.json();
      if (!res.ok) throw new Error(d?.message||`HTTP ${res.status}`);
      setPushStates((p)=>{ const c=[...p]; c[idx]={...c[idx],emailSt:{success:d?.message||`Sent to ${email}`}}; return c; });
    } catch (err) {
      setPushStates((p)=>{ const c=[...p]; c[idx]={...c[idx],emailSt:{error:err.message}}; return c; });
    }
  };

  // ── Export Excel ──────────────────────────────────────────────────────────
  const handleExportExcel = async () => {
    try {
      const body = { sap_payload_list: extractedRows.map((inv)=>({ extracted_data:[inv], document_file_path:'Uploaded via web interface', document_type:'PDF' })) };
      const res  = await fetch('https://ocrtool.savictech.com/api/export-invoices-excel', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body) });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const url  = window.URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url;
      const m = (res.headers.get('content-disposition')||'').match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      a.setAttribute('download', m ? m[1].replace(/['"]/g,'') : 'SAP_Invoices.xlsx');
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) { alert(`Export failed: ${err.message}`); }
  };

  const handleReset = () => {
    setStep(0); setFiles([]); setExtractedRows([]); setEditedRows([]);
    setPushStates([]); setUploadStage('idle'); setSelectedIdx(0);
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <div>
      {/* Step indicator */}
      {(() => {
        const STEP_META = [
          { icon: <FiUpload size={22}/>,      desc: 'Select & upload invoice files'       },
          { icon: <FiZap    size={22}/>,      desc: 'Auto-push to SAP · fix if failed'    },
        ];
        return (
          <div style={{
            display: 'flex', alignItems: 'center',
            background: 'linear-gradient(135deg,rgba(255,255,255,.92) 0%,rgba(239,246,255,.85) 100%)',
            border: '1px solid rgba(216,227,240,.9)',
            borderRadius: 22,
            padding: '18px 28px',
            marginBottom: 24,
            boxShadow: '0 4px 24px rgba(12,28,52,.09)',
            backdropFilter: 'blur(14px)',
            position: 'relative', overflow: 'hidden',
            gap: 0,
          }}>
            {/* Top gradient accent bar */}
            <div style={{
              position:'absolute', top:0, left:0, right:0, height:3,
              background: step >= 1
                ? 'linear-gradient(90deg,#059669 0%,#16a34a 100%)'
                : 'linear-gradient(90deg,#0f4c81 0%,#147699 50%,rgba(216,227,240,.5) 100%)',
              borderRadius:'22px 22px 0 0',
              transition:'background .4s',
            }}/>

            {STEPS.map((label, i) => {
              const isDone   = i < step;
              const isActive = i === step;
              return (
                <React.Fragment key={label}>
                  {/* Step item — flexShrink:0 so it stays compact */}
                  <div style={{ display:'flex', alignItems:'center', gap:12, flexShrink:0 }}>
                    {/* Circle */}
                    <div style={{
                      width:48, height:48, borderRadius:'50%', flexShrink:0,
                      display:'flex', alignItems:'center', justifyContent:'center',
                      background: isDone
                        ? 'linear-gradient(135deg,#059669,#047857)'
                        : isActive
                          ? 'linear-gradient(135deg,#0f4c81,#147699)'
                          : 'rgba(216,227,240,.55)',
                      color: isDone || isActive ? '#fff' : '#9ab0c8',
                      boxShadow: isDone
                        ? '0 4px 16px rgba(5,150,105,.4)'
                        : isActive
                          ? '0 4px 18px rgba(15,76,129,.42)'
                          : 'none',
                      border: isDone || isActive ? 'none' : '2px solid rgba(216,227,240,.9)',
                      transition: 'all .3s ease',
                    }}>
                      {isDone ? <FiCheckCircle size={20}/> : STEP_META[i].icon}
                    </div>

                    {/* Text */}
                    <div>
                      <div style={{
                        fontSize:'0.88rem', fontWeight:800,
                        fontFamily:"'Space Grotesk',sans-serif",
                        color: isDone ? '#059669' : isActive ? '#0f4c81' : '#b0bec5',
                        marginBottom:2, transition:'color .3s', whiteSpace:'nowrap',
                      }}>{label}</div>
                      <div style={{
                        fontSize:'0.71rem', fontWeight:500, whiteSpace:'nowrap',
                        color: isDone ? 'rgba(5,150,105,.72)' : isActive ? '#4a6080' : '#c4d0dc',
                        transition:'color .3s',
                      }}>{STEP_META[i].desc}</div>
                    </div>
                  </div>

                  {/* Connector — flex:1 fills all remaining space */}
                  {i < STEPS.length - 1 && (
                    <div style={{
                      flex:1, minWidth:40, display:'flex', alignItems:'center',
                      margin:'0 16px', position:'relative',
                    }}>
                      <div style={{
                        flex:1, height:4, borderRadius:4,
                        background: isDone
                          ? 'linear-gradient(90deg,#059669,#4ade80)'
                          : 'rgba(216,227,240,.7)',
                        transition:'background .4s', position:'relative',
                      }}>
                        {isDone && (
                          <div style={{
                            position:'absolute', right:-5, top:'50%',
                            transform:'translateY(-50%)',
                            width:10, height:10, borderRadius:'50%',
                            background:'#4ade80',
                            boxShadow:'0 0 0 4px rgba(74,222,128,.22)',
                          }}/>
                        )}
                      </div>
                    </div>
                  )}
                </React.Fragment>
              );
            })}

            {/* Progress pill */}
            <div style={{
              marginLeft:16, padding:'6px 18px', flexShrink:0,
              background: step >= STEPS.length - 1
                ? 'linear-gradient(135deg,rgba(5,150,105,.12),rgba(16,185,129,.08))'
                : 'rgba(15,76,129,.08)',
              border:`1px solid ${step >= STEPS.length - 1 ? 'rgba(5,150,105,.25)' : 'rgba(15,76,129,.18)'}`,
              borderRadius:999,
              fontSize:'0.72rem', fontWeight:800,
              color: step >= STEPS.length - 1 ? '#059669' : '#0f4c81',
              transition:'all .3s',
            }}>
              Step {step + 1} / {STEPS.length}
            </div>
          </div>
        );
      })()}

      {/* ══════════════════════════════════════════════════
          STEP 1 — UPLOAD
      ══════════════════════════════════════════════════ */}
      {step === 0 && (
        <div className="inv-card">
          {/* Drop zone */}
          <div
            className={`inv-drop-zone${dragOver ? ' drag-over' : ''}`}
            style={{ padding:'60px 24px' }}
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={handleDrop}
            onClick={() => !uploading && fileRef.current?.click()}
          >
            <div style={{
              width:80, height:80, borderRadius:24,
              background: dragOver ? 'linear-gradient(135deg,#147699,#0f4c81)' : 'linear-gradient(135deg,#0f4c81,#147699)',
              display:'flex', alignItems:'center', justifyContent:'center',
              margin:'0 auto 20px', color:'#fff',
              boxShadow: dragOver ? '0 8px 32px rgba(15,76,129,.5)' : '0 6px 24px rgba(15,76,129,.35)',
              transform: dragOver ? 'scale(1.08)' : 'scale(1)',
              transition:'all .22s ease',
            }}>
              <FiUpload size={34}/>
            </div>
            <h4 style={{ fontSize:'1.15rem', fontWeight:800, color:'var(--ink)', margin:'0 0 8px', fontFamily:"'Space Grotesk',sans-serif" }}>
              {dragOver ? '✦ Release to upload' : 'Drop your invoices here'}
            </h4>
            <p style={{ fontSize:'0.85rem', color:'var(--sub)', margin:'0 0 20px' }}>or click to browse · multiple files supported</p>
            <div style={{ display:'flex', gap:8, justifyContent:'center', flexWrap:'wrap' }}>
              {['PDF','PNG','JPG','XLSX'].map((t) => (
                <span key={t} style={{ padding:'4px 14px', borderRadius:999, background:'rgba(15,76,129,.08)', border:'1px solid rgba(15,76,129,.18)', fontSize:'0.74rem', fontWeight:800, color:'var(--blue-1)', letterSpacing:'0.5px' }}>{t}</span>
              ))}
            </div>
            <input ref={fileRef} type="file" multiple style={{ display:'none' }}
              accept=".pdf,.png,.jpg,.jpeg,.xlsx,.xls"
              onChange={(e) => addFiles(e.target.files)}/>
          </div>

          {/* File list */}
          {files.length > 0 && (
            <div style={{ marginTop:20 }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
                <span style={{ fontSize:'0.82rem', fontWeight:700, color:'var(--ink)', display:'flex', alignItems:'center', gap:6 }}>
                  <FiFile size={14} style={{ color:'var(--blue-1)' }}/> {files.length} file{files.length!==1?'s':''} ready
                </span>
                <button onClick={() => setFiles([])} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'0.76rem', color:'var(--sub)', fontWeight:600, display:'flex', alignItems:'center', gap:4 }}>
                  <FiX size={12}/> Clear all
                </button>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {files.map((f) => {
                  const ext = f.name.split('.').pop();
                  return (
                    <div key={f.name} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 14px', background:'rgba(255,255,255,.85)', border:'1px solid var(--border-lt)', borderRadius:12, gap:12 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:10, minWidth:0 }}>
                        <div style={{ width:36, height:36, borderRadius:9, flexShrink:0, background:fileColor(ext), display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:'0.6rem', fontWeight:800 }}>{ext.toUpperCase()}</div>
                        <div style={{ minWidth:0 }}>
                          <div style={{ fontSize:'0.84rem', fontWeight:600, color:'var(--ink)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{f.name}</div>
                          <div style={{ fontSize:'0.7rem', color:'var(--muted)', marginTop:1 }}>{fmtBytes(f.size)}</div>
                        </div>
                      </div>
                      <button onClick={(e)=>{ e.stopPropagation(); removeFile(f.name); }} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--muted)', padding:4, borderRadius:6, display:'flex' }}
                        onMouseEnter={(e)=>e.currentTarget.style.color='var(--red)'} onMouseLeave={(e)=>e.currentTarget.style.color='var(--muted)'}>
                        <FiX size={15}/>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Upload progress */}
          {uploading && (
            <div style={{ marginTop:16, display:'flex', alignItems:'center', gap:12, padding:'12px 18px', background:'linear-gradient(135deg,rgba(239,246,255,.9),rgba(255,244,234,.6))', border:'1px solid var(--blue-3)', borderRadius:12 }}>
              {[{key:'uploading',label:'Sending files'},{key:'processing',label:'Extracting data'},{key:'done',label:'Complete'}].map((s,i)=>{
                const isDone   = uploadStage==='done'||(uploadStage==='processing'&&i===0);
                const isActive = uploadStage===s.key;
                return (
                  <React.Fragment key={s.key}>
                    <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                      {isActive ? <div className="inv-spinner" style={{ width:13, height:13, borderWidth:2 }}/>
                        : <div style={{ width:13, height:13, borderRadius:'50%', background:isDone?'var(--green)':'var(--border)', flexShrink:0 }}/>}
                      <span style={{ fontSize:'0.8rem', fontWeight:isActive||isDone?700:400, color:isActive?'var(--blue-1)':isDone?'var(--green)':'var(--muted)', whiteSpace:'nowrap' }}>
                        {s.label}{isActive?'…':''}
                      </span>
                    </div>
                    {i<2 && <div style={{ flex:1, height:2, background:isDone?'var(--green)':'var(--border)', borderRadius:2, transition:'background .4s' }}/>}
                  </React.Fragment>
                );
              })}
            </div>
          )}

          {uploadError && <div className="inv-error-banner" style={{ marginTop:12 }}><FiAlertCircle size={14}/> {uploadError}</div>}

          {/* CTA */}
          <div style={{ marginTop:24 }}>
            <button className="inv-btn primary"
              style={{ width:'100%', justifyContent:'center', padding:'13px 24px', fontSize:'0.95rem', borderRadius:14 }}
              onClick={handleUpload} disabled={!files.length||uploading}>
              {uploading
                ? <><div className="inv-spinner"/>Processing {files.length} file{files.length!==1?'s':''}…</>
                : <><FiZap size={16}/>{files.length>0?`Extract & Push ${files.length} Invoice${files.length!==1?'s':''} to SAP`:'Extract & Push to SAP'}</>
              }
            </button>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════
          STEP 2 — REVIEW & PUSH  (Master-Detail)
      ══════════════════════════════════════════════════ */}
      {step === 1 && (
        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>

          {/* Summary counters */}
          <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
            {[
              { label:'Total',       val:extractedRows.length,                   color:'#0369a1', bg:'#e0f2fe', border:'#bae6fd', Icon:FiFile },
              { label:'Pushed',      val:pushStates.filter(s=>s.success).length, color:'#065f46', bg:'#d1fae5', border:'#6ee7b7', Icon:FiCheckCircle },
              { label:'Failed',      val:pushStates.filter(s=>s.error).length,   color:pushStates.some(s=>s.error)?'#b91c1c':'#64748b', bg:pushStates.some(s=>s.error)?'#fee2e2':'#f8fafc', border:pushStates.some(s=>s.error)?'#fca5a5':'#e2e8f0', Icon:FiAlertCircle },
              { label:'In Progress', val:pushStates.filter(s=>s.loading).length, color:'#92400e', bg:'#fef3c7', border:'#fde68a', Icon:FiZap },
            ].map(({ label, val, color, bg, border, Icon }) => (
              <div key={label} style={{ display:'flex', alignItems:'center', gap:10, background:bg, border:`1px solid ${border}`, borderRadius:12, padding:'10px 16px', minWidth:110 }}>
                <div style={{ width:34, height:34, borderRadius:8, background:color, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}><Icon size={16} color="#fff"/></div>
                <div>
                  <div style={{ fontSize:'0.63rem', fontWeight:700, color, textTransform:'uppercase', letterSpacing:'0.5px' }}>{label}</div>
                  <div style={{ fontSize:'1.4rem', fontWeight:900, color, lineHeight:1.1 }}>{val}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Master-Detail layout ── */}
          <div style={{ display:'flex', gap:14, alignItems:'flex-start' }}>

            {/* LEFT — invoice list (sticky sidebar) */}
            <div style={{
              width:264, flexShrink:0, display:'flex', flexDirection:'column',
              background:'rgba(255,255,255,.88)', border:'1px solid rgba(216,227,240,.8)',
              borderRadius:18, overflow:'hidden', boxShadow:'0 2px 14px rgba(12,28,52,.07)',
              position:'sticky', top:16,
              maxHeight:'calc(100vh - 200px)',
            }}>
              {/* List header */}
              <div style={{ padding:'13px 16px', background:'linear-gradient(135deg,rgba(239,246,255,.95),rgba(255,244,234,.5))', borderBottom:'1px solid rgba(216,227,240,.5)', flexShrink:0 }}>
                <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontWeight:800, fontSize:'0.85rem', color:'#0f4c81', display:'flex', alignItems:'center', gap:8 }}>
                  Invoices
                  <span style={{ background:'linear-gradient(135deg,#e56e11,#fb923c)', color:'#fff', fontSize:'0.63rem', fontWeight:800, padding:'1px 7px', borderRadius:999 }}>
                    {editedRows.length}
                  </span>
                </div>
                <div style={{ fontSize:'0.67rem', color:'#7a96b2', marginTop:2 }}>
                  {pushStates.filter(s=>s.success).length} pushed · {pushStates.filter(s=>s.error).length} failed · {pushStates.filter(s=>s.loading).length} in progress
                </div>
              </div>

              {/* Scrollable rows */}
              <div style={{ flex:1, overflowY:'auto' }}>
                {editedRows.map((row, idx) => {
                  const ps = pushStates[idx] || {};
                  const isSel = idx === selectedIdx;
                  const accent = ps.loading ? '#2563eb' : ps.success ? '#059669' : ps.error ? '#dc2626' : '#94a3b8';
                  const statusLabel = ps.loading ? 'Pushing…' : ps.success ? 'Pushed' : ps.error ? 'Failed' : 'Pending';
                  const pillBg      = ps.loading?'#dbeafe':ps.success?'#d1fae5':ps.error?'#fee2e2':'#f1f5f9';
                  const pillColor   = ps.loading?'#1e40af':ps.success?'#065f46':ps.error?'#991b1b':'#475569';
                  return (
                    <div
                      key={idx}
                      onClick={() => setSelectedIdx(idx)}
                      style={{
                        padding:'11px 14px 11px 0',
                        borderBottom:'1px solid rgba(216,227,240,.3)',
                        cursor:'pointer', transition:'background .12s',
                        background: isSel
                          ? ps.error?'linear-gradient(90deg,rgba(254,226,226,.6),rgba(255,241,242,.3))':ps.success?'linear-gradient(90deg,rgba(209,250,229,.6),rgba(240,253,244,.3))':'linear-gradient(90deg,rgba(219,234,254,.6),rgba(239,246,255,.3))'
                          : 'transparent',
                        display:'flex', alignItems:'stretch', gap:0,
                      }}
                      onMouseEnter={(e) => { if (!isSel) e.currentTarget.style.background = 'rgba(239,246,255,.5)'; }}
                      onMouseLeave={(e) => { if (!isSel) e.currentTarget.style.background = 'transparent'; }}
                    >
                      {/* Left accent bar */}
                      <div style={{ width:4, flexShrink:0, borderRadius:'0 3px 3px 0', background: isSel ? accent : 'transparent', marginRight:12, transition:'background .15s' }}/>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:6, marginBottom:4 }}>
                          <span style={{ fontSize:'0.8rem', fontWeight:800, color: isSel ? accent : '#1e293b', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', flex:1 }}>
                            {row._originalInvoiceNumber || row.invoice_number || `Invoice ${idx+1}`}
                          </span>
                          <span style={{ fontSize:'0.62rem', fontWeight:800, padding:'2px 7px', borderRadius:999, background:pillBg, color:pillColor, flexShrink:0, display:'flex', alignItems:'center', gap:3 }}>
                            {ps.loading && <div className="inv-spinner" style={{ width:8, height:8, borderWidth:1.5, color:pillColor }}/>}
                            {statusLabel}
                          </span>
                        </div>
                        {(row.invoice_date || row.invoice_total) && (
                          <div style={{ fontSize:'0.66rem', color:'#94a3b8', fontWeight:500 }}>
                            {row.invoice_date}{row.invoice_date && row.invoice_total ? ' · ' : ''}{row.invoice_total}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Footer */}
              <div style={{ padding:'10px 14px', borderTop:'1px solid rgba(216,227,240,.5)', flexShrink:0, background:'rgba(248,250,252,.8)' }}>
                <button className="inv-btn secondary" onClick={handleReset} style={{ width:'100%', justifyContent:'center', fontSize:'0.75rem', padding:'7px 10px' }}>
                  <FiRefreshCw size={12}/> Upload More
                </button>
              </div>
            </div>

            {/* RIGHT — detail panel */}
            {(() => {
              const idx       = selectedIdx;
              const row       = editedRows[idx];
              const ps        = pushStates[idx] || {};
              const cfg       = statusCfg(ps);
              const curInv    = extractedRows[idx];
              const lineItems    = curInv?._items || [];
              const lineItemKeys = lineItems.length > 0 ? Object.keys(lineItems[0]) : [];

              if (!row) return (
                <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', color:'var(--muted)', fontSize:'0.85rem' }}>
                  Select an invoice from the list
                </div>
              );

              return (
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{
                    background:'rgba(255,255,255,.95)',
                    border:`1px solid ${cfg.border}`,
                    borderRadius:20, overflow:'hidden',
                    boxShadow:'0 4px 24px rgba(12,28,52,.10)',
                  }}>

                    {/* ── Colored header band ── */}
                    <div style={{
                      background: cfg.bg,
                      borderBottom:`2px solid ${cfg.border}`,
                      padding:'20px 24px 16px',
                    }}>
                      {/* Top row: icon + title + nav */}
                      <div style={{ display:'flex', alignItems:'center', gap:14 }}>
                        {/* Status icon */}
                        <div style={{
                          width:52, height:52, borderRadius:14, flexShrink:0,
                          background: ps.loading?'linear-gradient(135deg,#2563eb,#1d4ed8)':ps.success?'linear-gradient(135deg,#059669,#047857)':ps.error?'linear-gradient(135deg,#dc2626,#b91c1c)':'linear-gradient(135deg,#0f4c81,#147699)',
                          display:'flex', alignItems:'center', justifyContent:'center', color:'#fff',
                          boxShadow: ps.success?'0 6px 20px rgba(5,150,105,.4)':ps.error?'0 6px 20px rgba(220,38,38,.4)':'0 6px 20px rgba(37,99,235,.4)',
                        }}>
                          {ps.loading ? <div className="inv-spinner" style={{ width:24, height:24, borderWidth:2.5 }}/>
                            : ps.success ? <FiCheckCircle size={24}/>
                            : ps.error   ? <FiAlertCircle size={24}/>
                            : <FiZap size={24}/>}
                        </div>

                        {/* Invoice number + status pill */}
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap', marginBottom:5 }}>
                            <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontWeight:900, fontSize:'1.18rem', color:'#0f1f35', letterSpacing:'-0.02em' }}>
                              {row._originalInvoiceNumber || row.invoice_number || `Invoice ${idx+1}`}
                            </span>
                            <span style={{ padding:'4px 12px', borderRadius:999, fontSize:'0.71rem', fontWeight:800, background:cfg.pillBg, color:cfg.pillColor, border:`1px solid ${cfg.pillBorder}`, display:'flex', alignItems:'center', gap:5 }}>
                              {ps.loading && <div className="inv-spinner" style={{ width:9, height:9, borderWidth:1.5, color:cfg.pillColor }}/>}
                              {cfg.label}
                            </span>
                          </div>
                          {/* Info chips */}
                          <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                            {[
                              row.invoice_date         && { label:'Date',  value:row.invoice_date },
                              row.purchase_order_number && { label:'PO',    value:row.purchase_order_number, mono:true },
                              row.invoice_total         && { label:'Total', value:row.invoice_total, bold:true },
                            ].filter(Boolean).map(chip => (
                              <div key={chip.label} style={{ display:'flex', alignItems:'center', gap:4, padding:'3px 10px', borderRadius:8, background:'rgba(255,255,255,.65)', border:'1px solid rgba(216,227,240,.7)', fontSize:'0.76rem' }}>
                                <span style={{ fontSize:'0.6rem', fontWeight:800, color:'#7a96b2', textTransform:'uppercase', letterSpacing:'0.4px' }}>{chip.label}</span>
                                <span style={{ fontWeight: chip.bold?800:700, color:'#12213a', fontFamily: chip.mono?'monospace':'inherit' }}>{chip.value}</span>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Prev / Next */}
                        <div style={{ display:'flex', alignItems:'center', gap:8, flexShrink:0 }}>
                          <button onClick={() => setSelectedIdx(i => Math.max(0, i-1))} disabled={selectedIdx===0}
                            style={{ width:34, height:34, borderRadius:10, border:'1px solid rgba(216,227,240,.9)', background:'rgba(255,255,255,.85)', cursor:selectedIdx===0?'default':'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'#4a6080', fontSize:'1rem', opacity:selectedIdx===0?.35:1, transition:'all .15s' }}
                            onMouseEnter={(e)=>{ if(selectedIdx>0){ e.currentTarget.style.background='#fff'; e.currentTarget.style.borderColor='#0f4c81'; e.currentTarget.style.color='#0f4c81'; }}}
                            onMouseLeave={(e)=>{ e.currentTarget.style.background='rgba(255,255,255,.85)'; e.currentTarget.style.borderColor='rgba(216,227,240,.9)'; e.currentTarget.style.color='#4a6080'; }}>
                            ‹
                          </button>
                          <span style={{ fontSize:'0.72rem', fontWeight:700, color:'#7a96b2', minWidth:36, textAlign:'center' }}>{idx+1} / {editedRows.length}</span>
                          <button onClick={() => setSelectedIdx(i => Math.min(editedRows.length-1, i+1))} disabled={selectedIdx===editedRows.length-1}
                            style={{ width:34, height:34, borderRadius:10, border:'1px solid rgba(216,227,240,.9)', background:'rgba(255,255,255,.85)', cursor:selectedIdx===editedRows.length-1?'default':'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'#4a6080', fontSize:'1rem', opacity:selectedIdx===editedRows.length-1?.35:1, transition:'all .15s' }}
                            onMouseEnter={(e)=>{ if(selectedIdx<editedRows.length-1){ e.currentTarget.style.background='#fff'; e.currentTarget.style.borderColor='#0f4c81'; e.currentTarget.style.color='#0f4c81'; }}}
                            onMouseLeave={(e)=>{ e.currentTarget.style.background='rgba(255,255,255,.85)'; e.currentTarget.style.borderColor='rgba(216,227,240,.9)'; e.currentTarget.style.color='#4a6080'; }}>
                            ›
                          </button>
                        </div>
                      </div>

                      {/* SAP status message inside header */}
                      {(ps.success || ps.error) && (
                        <div style={{ marginTop:14, padding:'10px 14px', borderRadius:10, background:ps.success?'rgba(5,150,105,.1)':'rgba(220,38,38,.08)', border:`1px solid ${ps.success?'rgba(5,150,105,.25)':'rgba(220,38,38,.22)'}`, display:'flex', alignItems:'center', gap:8 }}>
                          {ps.success
                            ? <><FiCheckCircle size={14} style={{ color:'#059669', flexShrink:0 }}/><span style={{ fontSize:'0.83rem', fontWeight:600, color:'#065f46' }}>{ps.success}</span></>
                            : <><FiAlertCircle size={14} style={{ color:'#dc2626', flexShrink:0 }}/><span style={{ fontSize:'0.83rem', fontWeight:600, color:'#991b1b', flex:1 }}>{ps.error}</span></>
                          }
                        </div>
                      )}
                    </div>

                    {/* Extracted fields */}
                    {curInv && displayKeys(curInv).length > 0 && (
                      <div style={{ padding:'0 20px' }}>
                        <Divider label="Extracted Fields"/>
                        <div className="inv-extracted-grid" style={{ marginBottom:0 }}>
                          {displayKeys(curInv).map((key) =>
                            curInv[key]!=null && curInv[key]!=='' ? (
                              <div key={key} className="inv-extracted-kv">
                                <div className="kv-label">{key}</div>
                                <div className="kv-value" title={String(curInv[key])}>{String(curInv[key])}</div>
                              </div>
                            ) : null
                          )}
                        </div>
                      </div>
                    )}

                    {/* Line items */}
                    {lineItems.length > 0 && (
                      <div style={{ padding:'0 20px' }}>
                        <Divider label={`Line Items (${lineItems.length})`}/>
                        <div style={{ borderRadius:12, overflow:'hidden', border:'1px solid rgba(216,227,240,.7)', marginBottom:4 }}>
                          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.82rem' }}>
                            <thead>
                              <tr>
                                <th style={{ padding:'10px 14px', background:'linear-gradient(135deg,rgba(239,246,255,.95),rgba(255,244,234,.4))', color:'var(--blue-1)', fontWeight:800, textAlign:'left', borderBottom:'2px solid var(--blue-3)', fontSize:'0.72rem', whiteSpace:'nowrap' }}>#</th>
                                {lineItemKeys.map((k) => (
                                  <th key={k} style={{ padding:'10px 14px', background:'linear-gradient(135deg,rgba(239,246,255,.95),rgba(255,244,234,.4))', color:'var(--blue-1)', fontWeight:800, textAlign:'left', borderBottom:'2px solid var(--blue-3)', fontSize:'0.72rem', whiteSpace:'nowrap' }}>{k}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {lineItems.map((item, li) => (
                                <tr key={li} style={{ background: li%2===0?'rgba(255,255,255,.7)':'rgba(239,246,255,.3)' }}
                                  onMouseEnter={(e)=>e.currentTarget.style.background='rgba(219,234,254,.35)'}
                                  onMouseLeave={(e)=>e.currentTarget.style.background=li%2===0?'rgba(255,255,255,.7)':'rgba(239,246,255,.3)'}>
                                  <td style={{ padding:'9px 14px', borderBottom:'1px solid rgba(216,227,240,.4)', color:'var(--muted)', fontWeight:700, fontSize:'0.75rem' }}>{li+1}</td>
                                  {lineItemKeys.map((k) => (
                                    <td key={k} style={{ padding:'9px 14px', borderBottom:'1px solid rgba(216,227,240,.4)', color:'var(--ink)' }}>{String(item[k]??'—')}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* Edit form (on failure) */}
                    {ps.error && (
                      <div style={{ padding:'0 20px 4px', marginTop:12 }}>
                        <button onClick={() => toggleShowEdit(idx)}
                          style={{ display:'flex', alignItems:'center', gap:6, background:'none', border:'none', cursor:'pointer', fontSize:'0.8rem', fontWeight:700, color:ps.showEdit?'var(--sub)':'var(--blue-1)', padding:'4px 0', marginBottom:ps.showEdit?10:0 }}>
                          <FiEdit3 size={13}/>
                          {ps.showEdit ? 'Cancel edit' : 'Edit invoice details & retry'}
                        </button>
                        {ps.showEdit && (
                          <div style={{ background:'rgba(255,255,255,.92)', border:'1px solid var(--border-lt)', borderRadius:14, overflow:'hidden', marginBottom:4 }}>
                            <div style={{ padding:'12px 18px', background:'linear-gradient(135deg,rgba(239,246,255,.9),rgba(255,244,234,.6))', borderBottom:'1px solid var(--border-lt)', display:'flex', alignItems:'center', gap:8 }}>
                              <FiEdit3 size={14} style={{ color:'var(--blue-1)' }}/>
                              <span style={{ fontWeight:700, fontSize:'0.84rem', color:'var(--ink)' }}>Fix & Retry</span>
                              <span style={{ fontSize:'0.74rem', color:'var(--sub)' }}>Update fields below and push again</span>
                            </div>
                            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, padding:'16px 18px' }}>
                              {[
                                { field:'invoice_number',        label:'Invoice Number', type:'text',  placeholder:'e.g. INV-2024-001' },
                                { field:'invoice_date',          label:'Invoice Date',   type:'date',  placeholder:'' },
                                { field:'invoice_total',         label:'Total Amount',   type:'text',  placeholder:'e.g. 12500' },
                                { field:'purchase_order_number', label:'PO Number',      type:'text',  placeholder:'e.g. PO-456' },
                                { field:'ap_processor',          label:'AP Processor',   type:'email', placeholder:'user@company.com' },
                              ].map(({ field, label, type, placeholder }) => (
                                <div key={field} style={{ display:'flex', flexDirection:'column', gap:5 }}>
                                  <label style={{ fontSize:'0.68rem', fontWeight:800, color:'var(--sub)', textTransform:'uppercase', letterSpacing:'0.5px' }}>{label}</label>
                                  <input type={type} value={row[field]||''} onChange={(e)=>updateField(idx,field,e.target.value)} placeholder={placeholder}
                                    style={{ padding:'9px 12px', border:'1.5px solid var(--border)', borderRadius:9, fontSize:'0.85rem', color:'var(--ink)', fontFamily:'inherit', background:'rgba(255,255,255,.85)', outline:'none', transition:'border .18s' }}
                                    onFocus={(e)=>{ e.target.style.borderColor='var(--o2c-teal)'; e.target.style.boxShadow='0 0 0 3px rgba(20,118,153,.1)'; }}
                                    onBlur={(e) =>{ e.target.style.borderColor='var(--border)';    e.target.style.boxShadow='none'; }}/>
                                </div>
                              ))}
                            </div>
                            <div style={{ padding:'0 18px 18px' }}>
                              <button className="inv-btn primary" style={{ width:'100%', justifyContent:'center', padding:'12px', fontSize:'0.9rem', borderRadius:12 }}
                                onClick={() => doPush(idx, editedRows)} disabled={ps.loading}>
                                {ps.loading ? <><div className="inv-spinner"/>Pushing…</> : <><FiZap size={15}/>Save & Push to SAP</>}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Actions bar */}
                    <div style={{ padding:'12px 20px 16px', marginTop:14, borderTop:'1px solid rgba(216,227,240,.45)', display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', background:'rgba(248,250,252,.6)' }}>
                      <div style={{ display:'flex', gap:6, flex:1, flexWrap:'wrap' }}>
                        {ps.emailSt?.success
                          ? <span style={{ display:'flex', alignItems:'center', gap:5, fontSize:'0.8rem', color:'var(--green)', fontWeight:600 }}><FiCheckCircle size={13}/> {ps.emailSt.success}</span>
                          : <button className="inv-btn ghost" style={{ fontSize:'0.8rem', padding:'6px 14px' }} onClick={() => handleSendEmail(idx)} disabled={ps.emailSt?.loading}>
                              {ps.emailSt?.loading ? <><div className="inv-spinner"/>Sending…</> : <><FiMail size={13}/>Send Email</>}
                            </button>
                        }
                        {ps.emailSt?.error && <span style={{ fontSize:'0.75rem', color:'var(--red)', alignSelf:'center' }}>{ps.emailSt.error}</span>}
                        <button className="inv-btn ghost" style={{ fontSize:'0.8rem', padding:'6px 14px' }} onClick={handleExportExcel}>
                          <FiDownload size={13}/> Export Excel
                        </button>
                      </div>
                      {ps.error && !ps.showEdit && (
                        <button className="inv-btn primary" style={{ fontSize:'0.8rem', padding:'6px 16px' }} onClick={() => doPush(idx, editedRows)} disabled={ps.loading}>
                          <FiZap size={12}/> Retry Push
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      )}
    </div>
  );
};

export default OCRProcess;
